/* eslint-disable linebreak-style */
/*
 * @FileName: Do not edit
 * @Date: 2022-02-11 10:07:54
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-09 10:01:45
 * @FilePath: \mobile-portal\src\lang\inner\zh-CN\common.js
 */
export default {
  common: {
    noData: '暂无数据',
    Know: '我知道了',
    noMore: '没有更多了',
    allCheck: '全选',
    success: '操作成功',
    searchMsg: 'Process ID / Process name /Applicant',
    SelectPersonnel: '选择人员',
    empty: '清空',
    confirm: '确认',
    selectClassification: '请选择流程分类',
    follow: '关注',
    focus: '已关注',
    participants: '人已参与',
    reply: '回复',
    replied: '已回复',
    invalid: '失效',
    failed: '提交失败',
    Home: 'Home',
    Process: '发起流程',
    Workbench: 'Workbench',
    enterMsg: '请输入人名/id',
    NoResult: '搜索无结果',
    NoDataSelected: '没有选中数据',
    loading: '加载中',
    cancel: '取消',
    recall: '召回',
    Notice: '公告',
    open: '展开',
    PutAway: '收起',
    year: '年',
    tips:'提示',
    approvalTips:'请确认是否执行【{0}】操作?',
  },
  message: {
    msg: '请输入流程名称',
    msg0: '请输入流程分类',
    msg1: '请选择流程状态为活动中的流程',
    msg2: '取消收藏成功！',
    msg3: '已经收藏！',
    msg4: '收藏成功！',
    msg5: '未查到该数据',
    msg6: '已选{0}人',
    msg7: '已选{0}条',
  },
  home: {
    todo: '我的待办',
    copy: '我的抄送',
    communicationo: '我的沟通',
    launch: '我的发起',
    involved: '我的已办',
    follow: '我的关注',
    process: '我的流程',
    participate: '我参与的',
    Submit: '我提交的',
  },
  workbench: {
    ComTime: '沟通时间',
    LaunchTime: '发起时间',
    EndTime: '结束时间',
    Sponsor: '发起人',
    Communicator: '沟通人',
    approve: '审批',
    opinion: '审批意见',
    enterMsg: '请输入审批意见',
    countersign: '加签',
    record: '流转记录',
    stopTime: '停留 {0} 天',
    calendar: '日期选择',
    startDate: '发起时间',
    attachmentDetails: '附件详情',
    containsWords:'包含字词',
    more:'More'
  },
  launch: {
    Collection: '收藏流程',
    Ownership: '拥有流程',
    All: '全部流程',
  },
  initiate: {
    initiate: '我的发起',
    AlreadyDone: '我的已办',
    recalled: '流程已被召回',
    successful: '召回成功！',
  },
  processSearch: {
    searchProcess: '查询流程',
    selectTime: '选择时间',
    date: '日期',
    containsWords: '包含字词',
    processStatus: '流程状态',
    applicator: '发起人',
    currentApprover: '当前审批人',
    selectPersonnel: '选择人员',
    expandMore: '展开更多',
    fold: '收起',
    personPlaceholder: '请选择人名/账号',
    latelySevenDay: '最近7天',
    today: '今天',
    allDay: '所有时间',
    customTime: '自定义时间',
    searchPlaceholder: '流程单号/流程名称/流程摘要/流程实例号',
  },
  myAccount: {
    setting: "设置",
    status: "状态",
    personnel: "个人信息",
    full: "姓",
    name: "名",
    onlyName: "姓名",
    gender: "性别",
    phone: "手机号",
    email: "邮箱",
    post: "岗位",
    organization: "组织",
    onJob: "在职",
    offJob: "离职",
    changeName: "修改姓名",
    changePwd: "修改密码",
    sysLang: "系统多语言",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    currentPasswordPlaceholder: "输入当前密码",
    newPasswordPlaceholder: "输入新密码",
    confirmNewPasswordPlaceholder: "再次输入新密码",
    enterTheCurrentPassword: "输入当前密码",
    enterTheNewPassword: "输入新密码",
    enterTheLastName: "输入姓",
    enterTheFirstName: "输入名",
    enterTheConfirmNewPassword: "再次输入新密码",
    twoPasswordsNotConsistent: "两次输入密码不一致!",
    passwordTips: "只能输入6-20位字符，包含大小写字母、数字及标点符号（除空格)",
    male: "男",
    female: "女",
    uploadAvatarTip: "上传头像图片只能是 JPG 或者png格式！",
    uploadSizeTip: "上传头像图片大小不能超过 500KB！",
    avatarUploadedSuccess: "头像上传成功！",
    failedUploadAvatar: "头像上传失败！",
    modifyPersonalInfoSuccess: "修改个人信息成功！",
    modifyPersonalInfoFailed: "修改个人信息失败！",
    changePasswordSuccess: "修改密码成功！",
    feedback: "意见反馈",
    isNotSet:'未设置'
  }
};
